import { GHAAccountType, GHAPropertyBrand } from '~/services/ConnectionGoogleService';

import { ACCOUNT_TYPES_BY_BRAND, ACCOUNT_TYPE_LABELS, ACCOUNT_TYPE_ORDER } from './constants';

export function getAccountTypesForBrand(brand: GHAPropertyBrand): Array<GHAAccountType> {
  const allowed = ACCOUNT_TYPES_BY_BRAND[brand] ?? [];
  return ACCOUNT_TYPE_ORDER.filter((type) => allowed.includes(type));
}

export function getAccountTypeOptionsForBrand(
  brand: GHAPropertyBrand,
): Array<{ value: GHAAccountType; label: string }> {
  return getAccountTypesForBrand(brand).map((value) => ({
    value,
    label: ACCOUNT_TYPE_LABELS[value],
  }));
}

export function filterAccountTypesForBrand(
  accountTypes: Array<GHAAccountType> | undefined,
  brand: GHAPropertyBrand,
): Array<GHAAccountType> {
  if (!accountTypes || accountTypes.length === 0) {
    return [];
  }
  const allowed = getAccountTypesForBrand(brand);
  return accountTypes.filter((type) => allowed.includes(type));
}

export function isAccountTypeValidForBrand(accountType: GHAAccountType | undefined, brand: GHAPropertyBrand): boolean {
  if (!accountType) {
    return false;
  }
  return getAccountTypesForBrand(brand).includes(accountType);
}
